import { useMemo } from "react";
import type { ChannelName, ChannelStatus } from "../../../../../channels/types";
import type { GetPersonsInSegmentJsonPerson } from "../../../../types/segment-schema";

export function usePersonsAndMissing(
  channel: ChannelName,
  data: GetPersonsInSegmentJsonPerson[],
): { persons: GetPersonsInSegmentJsonPerson[]; missing: GetPersonsInSegmentJsonPerson[] } {
  return useMemo(() => {
    if (!channel) return { persons: [], missing: [] };

    return (
      data?.reduce(
        (acc, person) => {
          const channelInfo = (person.channels as Record<NonNullable<ChannelName>, ChannelStatus>)[
            channel
          ];
          if (channelInfo) {
            if (!channelInfo.opted_out) acc.persons.push(person);
          } else acc.missing.push(person);
          return acc;
        },
        {
          persons: [] as GetPersonsInSegmentJsonPerson[],
          missing: [] as GetPersonsInSegmentJsonPerson[],
        },
      ) ?? { persons: [], missing: [] }
    );
  }, [data, channel]);
}
